import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { RemindersService }  from './reminders.service';

angular.module('app-lite.reminders', [])
  .service('remindersApi', downgradeInjectable(RemindersService));
